module.exports = __webpack_public_path__ + "static/assets/5077c1463187fdbba213732b9fa68970.svg";